import { TextField, TextFieldProps } from "@mui/material";
import { forwardRef } from "react";


const CustomTextField = forwardRef<HTMLDivElement, { readOnly?: boolean } & TextFieldProps>(({
    readOnly = false,
    ...others
}, ref) => {

    const { inputProps } = others;
    return <TextField
        ref={ref}
        {...others}
        inputProps={
            inputProps ? {
                readOnly: readOnly,
                sx: {
                    fontSize: "1.3rem",
                    textAlign: "left",
                },
                ...inputProps
            } : {
                readOnly: readOnly,
                sx: {
                    fontSize: "1.3rem",
                    textAlign: "left",
                },
            }}

    />
});

export default CustomTextField;